import { useAuthContext } from '../context/useAuthContext';
import { useLayoutContext } from '../context/useLayoutContext';
import AdminLayout from '../layouts/AdminLayout';
import HorizontalLayout from '../layouts/HorizontalLayout';
import OtherLayout from '../layouts/OtherLayout';
import { appRoutes, publicRoutes } from '../routes/index';
import { isMarketingAdminUser } from '../helpers/marketingAdmin';
import { Navigate, Route, Routes } from 'react-router-dom';
const AppRouter = props => {
  const {
    isAuthenticated,
    user
  } = useAuthContext();
  const {
    layoutOrientation
  } = useLayoutContext();
  const isMarketingAdmin = isMarketingAdminUser(user);
  const isMarketingAllowedRoute = routePath =>
    routePath === "/banner";
  return <Routes>
    {publicRoutes.map((route, idx) => <Route key={idx + route.name} path={route.path} element={<OtherLayout {...props}>{route.element}</OtherLayout>} />)}

    {(appRoutes || []).map((route, idx) => <Route key={idx + route.name} path={route.path} element={isAuthenticated ? isMarketingAdmin && !isMarketingAllowedRoute(route.path) ? <Navigate to="/banner" replace /> : layoutOrientation === 'vertical' ? <AdminLayout {...props}>{route.element}</AdminLayout> : <HorizontalLayout {...props}>{route.element}</HorizontalLayout> : <Navigate to={{
      pathname: '/auth/login',
      search: 'redirectTo=' + route.path
    }} />} />)}
  </Routes>;
};
export default AppRouter;
